import React, {useEffect} from 'react';
import s from './MainEducation.module.css';
import TopTitleBlock from '../../Components/TopTitleBlock/TopTitleBlock';
import EducationBackButton from '../../Components/Buttons/EducationBackButton';
import {useDispatch, useSelector} from 'react-redux';
import {
	getUserLessonsList,
	getUserModuleInfo,
	getUserSubModulesList,
} from '../../redux/education_Reducer';
import {RootState} from '../../redux/store';
import {useParams} from 'react-router-dom';
import EducationModules from './EducationComponents/EducationModules';
import MainEducationProgressLineTop from './EducationComponents/MainEducationProgressLineTop';

const EducationModulesPage: React.FC = () => {
	const dispatch: any = useDispatch();
	const auth = useSelector((state: RootState) => state.userData.auth);
	const apiData = useSelector((state: RootState) => state.appData.appData);
	/*const approve = useSelector(
    (state: StateType) => state.userData.authData.approve,
  );*/
	const {moduleType} = useParams();
	const getSubModulesList = useSelector(() => getUserSubModulesList);
	const getCurrentModuleInfo = useSelector(() => getUserModuleInfo);
	const getLessons = useSelector(() => getUserLessonsList);
	const userModuleInfo = useSelector(
		(state: RootState) => state.educationData.userModuleInfo,
	);
	const userModuleNavigation = useSelector(
		(state: RootState) => state.educationData.userModuleNavigation,
	);
	const userSubModuleList = useSelector(
		(state: RootState) => state.educationData.userSubModuleList,
	);
	const userLessonsList = useSelector(
		(state: RootState) => state.educationData.userLessonsList,
	);

	/*if(!apiData.response || apiData.response.length<=0) {
        //return <Navigate to={'/main_education'} />;
    }*/
	let nav_path = apiData.text_education;

	if (userModuleInfo) {
		nav_path += ' > ' + userModuleInfo.name;
	}
	if (userModuleNavigation && userModuleNavigation.length > 0) {
		nav_path = '';
		userModuleNavigation?.map((navigation: any, index: number) => {
			nav_path += (index ? ' > ' : '') + navigation.name;
		});
	}
	useEffect(() => {
		if (auth) {
			dispatch(getSubModulesList(moduleType ? +moduleType : 0));
			dispatch(getCurrentModuleInfo(moduleType ? +moduleType : 0));
			dispatch(getLessons(moduleType ? +moduleType : 0));
		}
	}, [moduleType, auth]);

	return (
		<main className={`${s.mainEducation} page`}>
			<div className="container">
				<div className="page__content">
					<TopTitleBlock pagination={nav_path} />
					<div className="page__module-one module-one">
						<EducationBackButton />
					</div>
				</div>
				<div className="page__module-one module-one">
					<div className={s.titleLesson}>
						<h3>{userModuleInfo?.fullname}</h3>
					</div>
				</div>
				<div className={`${s.contentContainer}`}>
					{userModuleInfo && (
						<MainEducationProgressLineTop
							text={userModuleInfo.text}
							img={userModuleInfo.img_banner}
							name={userModuleInfo.name}
							progress={userModuleInfo.progress}
							completed={userModuleInfo.completed}
						/>
					)}
					{userSubModuleList.length > 0 && (
						<EducationModules
							title={apiData.text_education_modules}
							link={'/main_education/'}
							subModules={userSubModuleList}
							textAccess={apiData.text_Access}
							textAccessDenied={apiData.text_accessDenied}
							textNotAvailable={apiData.text_notAvailable}
							textOneMoreTime={apiData.text_OneMoreTime}
						/>
					)}
					{userLessonsList && userLessonsList.length > 0 && (
						<EducationModules
							title={apiData.text_education_lessons}
							link={'/lesson/'}
							subModules={userLessonsList}
							textAccess={apiData.text_Access}
							textAccessDenied={apiData.text_accessDenied}
							textNotAvailable={apiData.text_notAvailable}
							textOneMoreTime={apiData.text_OneMoreTime}
						/>
					)}
				</div>
			</div>
		</main>
	);
};

export default EducationModulesPage;
